<template>
  <v-card height="400">
    <div v-if="saleUninitiated" class="container-div">
      <span class="checkout-h3">{{ saleUninitiated }}</span>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['saleUninitiated']),
  },
};
</script>

<style scoped>
.container-div {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>
